// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rm-2";
export var chatLink = "_rm-0";
export var chatText = "_rm-1";